import type { SVGProps } from 'react';
import { forwardRef } from 'react';

type SvgInfoProps = SVGProps<SVGSVGElement> & { size?: number };

const SvgInfo = forwardRef<SVGSVGElement, SvgInfoProps>(({ size = 24, ...props }, ref) => (
  <svg ref={ref} width={size} height={size} viewBox='0 0 24 24' data-testid='svg-icon-info' {...props}>
    <path d='M14 16a1 1 0 01-1 1h-2a1 1 0 010-2v-3a1 1 0 010-2h1a1 1 0 011 1v4a1 1 0 011 1zM12 2a10 10 0 0110 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 18a8 8 0 100-16 8 8 0 000 16zm0-11a1 1 0 110-2 1 1 0 010 2z' />
  </svg>
));

SvgInfo.displayName = 'SvgInfo';

export default SvgInfo;
